import { parse } from 'graphql'

export const QUOTE_FRAGMENT = parse(`
  fragment QuoteFragment on Quote {
    id
    status
    expiresAt
    cardIssuerDiscountRedeemable
    priceBreakdown {
      price {
        amount
        currency
        formatted
      }
      total {
        amount
        currency
        formatted
      }
      totalMinusStoredValueAuthorized {
        amount
        currency
        formatted
      }
      storedValueAuthorized {
        amount
        currency
        formatted
      }
      discount {
        amount
        currency
        formatted
      }
      cardIssuerDiscount {
        amount
        currency
        formatted
      }
      taxesAndFees {
        amount
        currency
        formatted
      }
      cityTax {
        amount
        currency
        formatted
      }
      stateTax {
        amount
        currency
        formatted
      }
      flatTax {
        amount
        currency
        formatted
      }
      foodAndBeverageTax {
        amount
        currency
        formatted
      }
      otherTax {
        amount
        currency
        formatted
      }
      retailTax {
        amount
        currency
        formatted
      }
      fees {
        amount
        currency
        formatted
      }
      peekProtectFee {
        amount
        currency
        formatted
      }
      tips {
        amount
        currency
        formatted
      }
    }
    bookingQuotes {
      refid
      priceBreakdown {
        price {
          formatted
        }
      },
      lines {
        description
        quantity
        sku
        priceBreakdown {
          price {
            amount
            formatted
          }
        }
        isChild
        tickets {
          name
        }
      }
      activitySnapshot {
        name
      },
      durationSnapshot {
        length {
          unit
        }
      }
      timeSnapshot {
        from
        until
        timezone
      }
    }
    promoCodes {
      code
      refid
      isApplied
      corePromoCodeSnapshot {
        fixedAmount {
          amount
          currency
          formatted
        }
        percentAmount
      }
    }
    tippingConfig {
      customEntryEnabled
      message
      tipOptions {
        label
        type
        value {
          amount
          currency
          formatted
        }
      }
    }
    authorizedPayments(paymentSourceType: STORED_VALUE) {
      authorizedAmount {
        amount
        currency
        formatted
      }
      id
      paymentSource {
        category
        id
        type
      }
      ... on StoredValuePayment {
        endingRedemptionCode
        remainingBalance {
          amount
          currency
          formatted
        }
      }
    }
    peekProtectSuggestion {
      rate
      value {
        amount
        currency
        formatted
      }
      protectedValue {
        amount
        currency
        formatted
      }
    }
  }
`)
